import "./style/main.scss";
import "./assets/fonts/Geist-LICENSE.txt";
import "./assets/figma/hero-desktop.avif";
import "./assets/figma/hero-desktop.webp";
import "./assets/figma/hero-mobile-lcp.avif";
import "./assets/figma/hero-mobile-lcp.webp";
import { initLanding } from "./landing";
import { initWinners } from "./winners";
import { createCampaignRuntimeConfig } from "./app/campaign";
import { campaignConfig } from "./campaign-config";

const runtimeConfig = createCampaignRuntimeConfig(campaignConfig);

function activateDeferredStyles() {
  document.querySelectorAll("link[data-deferred-style]").forEach((stylesheet) => {
    stylesheet.media = "all";
    stylesheet.removeAttribute("data-deferred-style");
  });
}

// La hoja ya se ha solicitado mediante preload. Activarla antes de montar los
// módulos evita un layout intermedio incompleto sin volver a bloquear el HTML.
activateDeferredStyles();

initLanding(runtimeConfig);
initWinners(runtimeConfig);
